<template>
  <div>
    <div v-if="isLogin">
      <table
        class="status-table board-list02 type01"
        v-if="pagedList.length"
        ref="histTable"
        :data="pagedList"
        height="96"
      >
        <thead>
          <tr></tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div v-for="(row, index) in pagedList" :key="index">
                <div class="history-card">
                  <div>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.date") }}</dt>
                      <dd>{{ row.ordDate }}</dd>
                    </dl>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.tokenName") }}</dt>
                      <dd>{{ ieCode }}</dd>
                    </dl>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.price") }}</dt>
                      <dd>
                        {{ row.coinCnt | formatNumber(8) }} {{ row.ciCode }}
                      </dd>
                    </dl>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.purchaseAmount") }}</dt>
                      <dd>{{ row.ieCoinCnt | formatNumber(6) }}</dd>
                    </dl>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.bonus") }}</dt>
                      <dd>{{ row.ieBonusCnt | formatNumber(6) }}</dd>
                    </dl>
                    <dl class="trade-row">
                      <dt>{{ $t("ieo.concluded.status") }}</dt>
                      <dd>{{ $t("confirm.done") }}</dd>
                      <!-- <dd>{{ row.status == "Y" ? "완료" : "실패" }}</dd> -->
                    </dl>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <Pagination
          :current-page="currentPage"
          :total-page="totalPage"
          @next-page="nextPage()"
          @prev-page="prevPage()"
          @first-page="firstPage()"
          @last-page="lastPage()"
          class="pagination"
        ></Pagination>
      </table>
      <div class="empty-history" v-else>{{ $t("ieo.history.empty") }}</div>
    </div>
    <!-- <div class="well" v-else-if="isLogin">
      <p v-html="$t('ieo.trade.messagePhone')"></p>
      <router-link
        :to="{ name: 'ConfirmCenter' }"
        class="btn-style01 btn-style-blue"
      >{{ $t("ieo.history.moveToAuthenticationCenter") }}</router-link>
    </div>-->
    <div class="well" v-else>
      <p>{{ $t("trade.login.logInTo") }}</p>
      <router-link :to="{ name: 'Login' }" class="btn-style01 btn-style-blue">
        {{ $t("resetPasswordPage.login") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Decimal from "decimal.js";
import Pagination from "@/components/common/pagination";

export default {
  data() {
    return {
      orderList: [], //전체
      pagedList: [], //현재페이지
      currentPage: 1,
      totalPage: 1,
    };
  },
  props: ["tkCode", "ieCode", "orderLists"],
  components: {
    Pagination,
  },
  created() {
    //로그인 된 경우만 common.js의 401 케이스 확인함
    if (this.$store.getters.isLogin) {
      this.getOrderHistory();
      setTimeout(() => {
        this.getOrderHistory();
      }, 1000);
    }
  },
  computed: {
    ...mapGetters(["isLogin", "authForIEO"]),
  },
  methods: {
    async getOrderHistory() {
      const { data } = await this.$api.IEO.getSaleHistory(this.tkCode);
      this.orderList = data.result;

      this.SortOrderHistory();
      this.PagedOrderHistory();
    },
    SortOrderHistory() {
      this.orderList.sort((a, b) => b.ordNo - a.ordNo);
    },
    PagedOrderHistory() {
      this.totalPage = Math.ceil(this.orderList.length / 5);
      this.currentPage = 1;
      this.pagedList = this.orderList.slice(0, 5);
    },
    nextPage() {
      if (this.currentPage == this.totalPage) return;
      this.currentPage++;
      this.goToPage(this.currentPage);
    },
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.goToPage(this.currentPage);
    },
    firstPage() {
      this.currentPage = 1;
      this.goToPage(this.currentPage);
    },
    lastPage() {
      this.currentPage = this.totalPage;
      this.goToPage(this.currentPage);
    },
    goToPage(pageNum) {
      console.log("goToPage");
      this.pagedList = this.orderList.slice((pageNum - 1) * 5, pageNum * 5);
    },
    getTotal(orderValue, bonusValue) {
      return Decimal(orderValue).add(bonusValue);
    },
  },
};
</script>

<style scoped lang="scss">
.well {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & > p {
    line-height: 1.9;
    padding: 12px;
  }
}
.history-card {
  margin: 15px auto 0;
  padding: 9px 12px;
  background: #f6f7fb;
  .trade-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    dt,
    dd {
      flex: 1 1 auto;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.64;
      letter-spacing: normal;
      text-align: left;
      color: #555555;
      display: flex;
      align-items: center;
    }
    dd {
      text-align: right;
      justify-content: flex-end;
      flex: 0 0 70%;
      input {
        max-width: 80%;
      }
    }
  }
}
.empty-history {
  width: 330px;
  height: 46px;
  margin: 15px auto 0;
  background: #f6f7fb;
  text-align: center;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 46px;
  letter-spacing: normal;
  text-align: center;
  color: #999999;
}
.pagination {
  margin-top: 10px;
}
</style>
